import { render, staticRenderFns } from "./FlvPlayerRealTimeHeguGb.vue?vue&type=template&id=21029cd4&scoped=true&"
import script from "./FlvPlayerRealTimeHeguGb.vue?vue&type=script&lang=js&"
export * from "./FlvPlayerRealTimeHeguGb.vue?vue&type=script&lang=js&"
import style0 from "./FlvPlayerRealTimeHeguGb.vue?vue&type=style&index=0&id=21029cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21029cd4",
  null
  
)

export default component.exports